import colors from './colors.mjs'
import chartColors from '@/composables/ChartColors'

export default {
  defaultTheme: 'light',
  themes: {
    light: {
      dark: false,
      colors: {
        primary: colors.blue.blue600,
        secondary: colors.neutral.neutral1000,
        success: colors.green.green500,
        warning: colors.yellow.yellow600,
        error: colors.red.red600,
        info: colors.blue.blue700,
        // background: '#28243D',
        // surface: '#312D4B',
        // 'on-primary': '#FFFFFF',
        // 'on-secondary': '#fff',
        // 'on-success': '#FFFFFF',
        // 'on-warning': '#FFFFFF',
        // 'on-error': '#FFFFFF',
        // 'on-info': '#FFFFFF',
        // 'on-background': '#E7E3FC',
        // 'on-surface': '#E7E3FC',
        // WASABI COLORS
        'on-blue100': '#353535',
        'on-green000': '#353535',
        'on-orange100': '#353535',
        'on-red000': '#353535',
        ...colors.blue,
        ...colors.orange,
        ...colors.neutral,
        ...colors.green,
        ...colors.yellow,
        ...colors.red,
        ...colors.coral,
        ...chartColors.blueChart,
        ...chartColors.tealChart,
        ...chartColors.purpleChart,
        ...chartColors.redChart,
        ...chartColors.greenChart,
        ...chartColors.brownChart,
        ...chartColors.yellowChart,
        ...chartColors.pinkChart,
        ...chartColors.peachChart,
        ...chartColors.grayChart
      },
      variables: {
        'border-color': colors.neutral.neutral1000,
        'btn-height': '34px',

        // Shadows
        'shadow-key-umbra-opacity': 'rgba(20, 18, 33, 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(20, 18, 33, 0.12)',
        'shadow-key-ambient-opacity': 'rgba(20, 18, 33, 0.04)'
      }
    }
  }
}
